import { createContext } from "react";

export const EditCompanyContext = createContext();